module.exports = __webpack_public_path__ + "img/img_15.cb7625ec.webp";